import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";
import CryptoJS from "react-native-crypto-js";


export  const MgmTracking = (props) => {

    //console.log(JSON.stringify(props))
    const Domain = window.location.hostname;

    let cryptoEmail = CryptoJS.AES.encrypt( `${props.email}`, 'MgmAklamio2021').toString();
    const base64CryptoEmail = btoa(cryptoEmail);

    let ProductAklamioArray = ''
    if (Domain == 'funnel.vivigas.it') {
        ProductAklamioArray = ['13094', '13097', '13099']

    }
    if (Domain == 'funnelvivigas.alkemy.com') {
        ProductAklamioArray = ['8789', '8782', '8777']
    }
    const ProdAklamio = ProductAklamioArray;
    let Category = ''
    if( props.name == 'VIVIweb Luce') {
        Category = 'luce'
    }
    if( props.name =='VIVIweb Gas') {
        Category = 'gas'
    }
    if( props.name =='VIVIweb LuceGas') {
        Category = 'luce_gas'
    }
    const setCategory = Category


    let Attribution = ''
    if( ProdAklamio.indexOf(`${props.offerId}`)>= 0 ) {
        Attribution = 'Aklamio'
    }
    const trackingAttribution = Attribution
    //console.log(props.name)
    return(
        <div className="MGMAklamio">
            <Helmet>
                <script type="text/javascript">
                    {`
                    try {
                        const request = com.aklamio.sales.createRequest(
                            '7781d0b99341f6ba7edd44672a4e6e15',
                            '${props.userId}', 
                            'funnelWeb',
                        );
                        request
                        .setTrackingAttribution('${trackingAttribution}');
                        const item = com.aklamio.sales.createItem(
                            '${props.offerId}'                 
                        );
                        item
                            .setName('${props.name}')
                            .setCategory('${setCategory}')
                            .setRewardCategory('${setCategory}')
                        request.addItem(item)
                        request.validate()
                        request.send()
                        } catch (e) {
                            console.error("Exception thrown", e);
            }
    `}
                 </script>

            </Helmet>
        </div>)
};